import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { ListAppointmentsWidget } from '@frontend/schedule';
import { ContactDetails } from '../../../contact-details/contact-details';
import { CustomerDetailsProps } from '../../customer-details';
import { AppointmentInformation } from './appointment-information';

type AppointmentSectionContainerProps = {
  showAppointmentStatus: boolean;
  hasRecallIntegration: boolean;
};

export const AppointmentSectionContainer = ({
  data,
  locationId,
  showAppointmentStatus,
  hasRecallIntegration,
}: CustomerDetailsProps & AppointmentSectionContainerProps) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  if (!data) return null;

  return (
    <>
      {isScheduleV3FlagEnabled && (
        <ContactDetails>
          <ListAppointmentsWidget person={data} locationId={locationId || ''} />
        </ContactDetails>
      )}
      {!isScheduleV3FlagEnabled && showAppointmentStatus && (
        <ContactDetails>
          <AppointmentInformation
            data={data}
            hasRecallIntegration={!!hasRecallIntegration}
            locationId={locationId || ''}
          />
        </ContactDetails>
      )}
    </>
  );
};
